
import { IconButton, MenuItem, Menu, Avatar } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useQueryClient } from 'react-query';
import { clearSessionState } from 'src/auth/session';


const AvatarIcon = () => {
  const { logout, user } = useAuth0();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const handleLogout = () => {
    clearSessionState({ dispatch, queryClient });
    logout({
      logoutParams: {
        returnTo: globalThis.location.origin,
      },
    });
  };
  
  return (
    <>
        <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
            data-testid={'user-data'}
        >
            {user?.picture ? (
                <Avatar alt={user.name} src={user.picture} data-testid={'data-avatar'} sx={{ width: 48, height: 48 }}/>
            ) : (
                <Avatar data-testid={'data-avatar'} sx={{ width: 48, height: 48 }}>{user.name?.charAt(0)}</Avatar>
            )}
        </IconButton>
        <Menu
            id="menu-appbar"
            data-testid="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
        >
            <MenuItem onClick={handleLogout}>Cerrar Sesión</MenuItem>
        </Menu>
    </>
  );
};

export default AvatarIcon;
